import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { messages } from './SingleSignOnFailedForm.i18n';
import { loadSupportedLanguages } from '../../redux/modules/capability/capability-middleware';
import { languageChange } from '../../redux/modules/language/language-middleware';

class SingleSignOnFailedForm extends Component {
  UNSAFE_componentWillMount() {
    this.props.dispatch(loadSupportedLanguages());
  }

  handleClick = (lang) => {
    this.props.dispatch(languageChange(lang));
  }
  render() {
    const { formatMessage } = this.props.intl;
    const text = formatMessage(messages.page.singleSignOnFailed);
    return (
      <div className="container">
        <div className="row" id="body">
           <div className="col">
             <div className="row justify-content-md-center mt-3">
                <div className="col-md-8">
                  <h1 id="content">
                    <span className="title">
                    <FormattedMessage {...messages.page.singleSignOnFailedTitle} />
                    </span>
                  </h1>
                        <div className="card p-3">
                          <div className="card-body">
                            <div className="content-area mb-3">
                            <div dangerouslySetInnerHTML={{ __html: text }}
                              tabIndex="0"
                            >
                            </div>
                            </div>
                            <div className="small languages">
                            {this.props.supportedLanguages.filter((lang) =>
                              lang.languageCode !== this.props.language.languageCode).map((lang) =>
                              (<a key={lang.languageCode} onClick={() => this.handleClick(lang.languageCode)}
                                role="link" tabIndex="0"
                              >
                                  {lang.displayName + ' '}
                               </a>)
                            )}
                            </div>
                          </div>
                        </div>
                </div>
             </div>
           </div>
        </div>
      </div>
    );
  }
}

SingleSignOnFailedForm.propTypes = {
  dispatch: PropTypes.func,
  language: PropTypes.object.isRequired,
  supportedLanguages: PropTypes.array.isRequired,
  intl: PropTypes.object,
};

const mapStateToProps = (state) => ({
  language: state.language,
  supportedLanguages: state.capability.languages,
});

export default connect(mapStateToProps)(injectIntl(SingleSignOnFailedForm));